import React, { useContext } from 'react';
import { GoogleLogin } from 'react-google-login';
import { useStyletron } from 'baseui';
import { AppContext, DASHBOARD, UserContext } from 'commons-ui';
import config from 'config';
import logo from './assets/zupee.png';

const Login: React.FC<{}> = () => {
	const { loginUser } = useContext(UserContext);
	const { showAlert } = useContext(AppContext);

	const [css] = useStyletron();

	const onSuccess = async (response: any) => {
		const { tokenObj, profileObj } = response;
		const err = await loginUser(tokenObj.id_token, tokenObj.access_token, profileObj, DASHBOARD.MARKETING);
		if (err) {
			showAlert('Please enter correct username and password', { type: 'error' });
		}
	};

	const onFailure = () => {
		showAlert('Error occured', { type: 'error' });
	};

	return (
		<div
			className={css({
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				height: '100%',
				width: '100%'
			})}>
			<div
				className={css({
					display: 'flex',
					justifyContent: 'space-around',
					width: '100%'
				})}>
				<div
					className={css({
						display: 'flex',
						justifyContent: 'space-around',
						flexDirection: 'column'
					})}>
					<div>
						<h1
							className={css({
								textAlign: 'center',
								marginBottom: '20%'
							})}>
							MARKETING DASHBOARD
						</h1>
					</div>
					<div>
						<img src={logo} alt='zupee-logo' height='200px' />
					</div>
				</div>
				<div
					className={css({
						height: '400px',
						borderLeft: '1px solid black'
					})}
				/>
				<div
					className={css({
						display: 'flex',
						justifyContent: 'space-around',
						flexDirection: 'column'
					})}>
					<div>
						<GoogleLogin
							clientId={config.GCLIENT_ID}
							onSuccess={onSuccess}
							onFailure={onFailure}
							className={css({
								width: '200px',
								height: '70px',
								fontSize: '16px !important',
								color: 'black !important'
							})}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Login;
